import { format } from 'date-fns';

export const getDateString = (date: Date | null | undefined, placeholder: string) => {
  if (!date) return placeholder;
  return format(date, 'LLL. dd. yyyy');
};
